/**
 * @param {array} itemsArray Array with full list of items
 * @param {string} ItemName Name of the item
 * @param {boolean} removeOrAddItems if true remove the itemName from the list, 
 *                                   if false add itemName into the list again.
 */

let removedItems = [] // Here we store the removed Items

export const handleDropdownItems =  (itemsArray, itemName, removeOrAddItems) => {
  let selectedArr = removeOrAddItems ? itemsArray : removedItems
  let arrToPushItems = removeOrAddItems ? removedItems : itemsArray

  for (let index = 0; index < selectedArr.length; index++) {
    if (selectedArr[index].name == itemName || selectedArr[index].continent == itemName) {
      arrToPushItems.push(selectedArr[index]) 
      selectedArr.splice(index, 1)
      index--
    }
  }
};

// This is exclusive for Continents and Countries.
// If a "country pill" bellong a "continent pill", we remove the country pill
export const removePillsIfBellongToContinent = continentName => {
  const pillsContainer = document.querySelector('#js-pills-area-container')
  for (let index = 0; index < removedItems.length; index++) {
    if (removedItems[index].continent != continentName) return
    
    for (let i = 0; i < pillsContainer.children.length; i++) {
      if (pillsContainer.children[i].getAttribute('name') === removedItems[index].name) {
        pillsContainer.children[i].remove()
      } 
    }
  }
}


// Removing from the list of Expertises and Continents/Countries  
// the selected item and if we have a preselected Continent, remove all
// countries related to that Continent.
export const initialUpdateDropdownListItems = dropdownListItems => {
  const pillsContainer = document.querySelectorAll('.profile__pills-container')

  pillsContainer.forEach( container => {
    if (container.classList.contains('js-skills-pills') || container.children.length == 0) return;
    // Iterating through all preselected pills
    for (let i = 0; i < container.children.length; i++) {
      let pillName = container.children[i].getAttribute('name')
      
      // Iterating through all dropdown items in the list and if 
      // the pills name is equal to dropdown item, remove it from the list
      // and store the removed item in removedItems Array.
      for (let index = 0; index < dropdownListItems.length; index++) {
        let listItem = dropdownListItems[index]

        if (pillName === listItem.name || pillName === listItem.continent) {
          removedItems.push(dropdownListItems[index])
          dropdownListItems.splice(index, 1)
          index--
        }
      } 
    }
  })
}